import { ApplicationConfig, ErrorHandler } from '@angular/core';
import { provideRouter, withRouterConfig } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { WindowRef } from './common/core/domain/window-ref';
import { GlobalErrorHandlerService } from './common/core/error/global-error-handler.service';
import { baseUrlInterceptor } from './common/core/http-interceptor/base-url.interceptor';
import { headerInterceptor } from './common/core/http-interceptor/header.interceptor';
import { loadingInterceptor } from './common/core/http-interceptor/loading.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    // Angular 22 defaults to 'always'; keep pre-v22 param inheritance behavior
    provideRouter(routes, withRouterConfig({ paramsInheritanceStrategy: 'emptyOnly' })),
    provideHttpClient(withInterceptors(
      [headerInterceptor, baseUrlInterceptor, loadingInterceptor],
    )),
    WindowRef,
    GlobalErrorHandlerService,
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandlerService
    }
  ]
};
